export default __webpack_public_path__ + "fd62a10743bd89a3d97caa48d89eb4f5.ttf";